import React, { useState } from 'react';
import { Button, Segmented } from 'antd';
import { ArrowLeftIcon, ArrowRightIcon, InfoCircleIcon, SecondNoteIcon, TestEyeIcon, TestStartIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { globalConst, openHeartModal, parseSubjectName, slugify, useCheckLimit } from 'modules/global';
import { ITestProps, TestFaolIshtrokchilar, TestFikrlar, useTopicTestInfo } from 'modules/mavzuli-test';

import { Modal } from 'components';

interface IProps {
  open: boolean;
  onClose: () => void;
  selectedData: ITestProps | undefined;
}

const TestModal = ({ open, onClose, selectedData }: IProps) => {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState(t('faol_ishtirokchilar'));
  const { data: info, isLoading: isInfloLoading } = useTopicTestInfo(selectedData?.testId);
  const { push } = useRouter();
  const user = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();
  const { mutate, isLoading: mutationLoading } = useCheckLimit();
  const isLoading = useAppSelector(state => state.routeLoading.isRouteLoading);

  const handleStart = () => {
    if (!user?.phone) {
      const slug = slugify(selectedData?.lessonName || '');

      push({
        pathname: `${globalConst.pageNames.TOPIC_TEST}/${parseSubjectName(selectedData?.subjectName)?.toLowerCase()}/${selectedData?.testId}-${slug}`
      });
      return;
    }

    mutate('mavzuli-test', {
      onSuccess: data => {
        if (data.allowed) {
          const slug = slugify(selectedData?.lessonName || '');

          push({
            pathname: `${globalConst.pageNames.TOPIC_TEST}/${parseSubjectName(selectedData?.subjectName)?.toLowerCase()}/${selectedData?.testId}-${slug}`
          });
        } else {
          dispatch(openHeartModal());
        }
      }
    });
  };

  return (
    <div>
      <Modal
        footer={false}
        open={open}
        centered
        onClose={() => onClose()}
        width="429px"
        closeIcon={false}
        styles={{
          content: { padding: '16px', borderRadius: '12px' }
        }}
        title={<div className="inline rounded-md bg-gray-100 px-2 py-1 text-sm">{selectedData?.subjectName}</div>}
      >
        <h4 className="mt-4 text-lg font-medium">{selectedData?.lessonName}</h4>

        <div className="mt-3 inline-flex items-end gap-5 rounded-xl bg-gray-50 px-3 py-2 ">
          <div className="flex items-center gap-1">
            <TestStartIcon />
            {selectedData?.testRating}
          </div>
          <div className="flex items-center gap-1">
            <SecondNoteIcon />
            {selectedData?.testCount} {t('test')}
          </div>
          <div className="flex items-center gap-1">
            <TestEyeIcon />
            {selectedData?.viewCount}
          </div>
        </div>

        <div className="min-h-70 mt-4 rounded-lg border border-gray-200 p-2">
          <Segmented
            options={[t('faol_ishtirokchilar'), t('fikrlar')]}
            block
            className="!font-medium"
            value={activeTab}
            onChange={value => setActiveTab(value as string)}
          />
          <div className="mt-2">
            {activeTab === t('faol_ishtirokchilar') && (
              <TestFaolIshtrokchilar
                testCount={selectedData?.testCount}
                data={info?.top_user}
                loading={isInfloLoading}
              />
            )}
            {activeTab === t('fikrlar') && <TestFikrlar data={info?.test_rating} loading={isInfloLoading} />}
          </div>
        </div>

        <div className="mt-3 flex gap-2 rounded-lg bg-yellow-50 p-3">
          <div className="mt-1 flex-shrink-0">
            <InfoCircleIcon />
          </div>
          <div className="">
            <h4 className="mb-1 font-medium">{t('xp_qanday_ishlaydi')}</h4>
            <p className="text-xs">{t('xp_qanday_ishlaydi_desc')}</p>
          </div>
        </div>

        <div className="mt-3 flex items-center gap-2">
          <Button
            onClick={() => onClose()}
            className="!rounded-lg !border-none !bg-gray-50 !px-3 !py-5 hover:!border-none hover:!text-black"
          >
            <div className="mt-0.5 ">
              <ArrowLeftIcon size="17" />
            </div>
            {t('ortga')}
          </Button>
          <Button
            loading={mutationLoading || isLoading}
            onClick={handleStart}
            className="!w-full !rounded-lg !border-none !bg-green-500 !px-7 !py-5 !text-white hover:!border-none"
          >
            {t('boshlash')}
            <div className="mt-0.5 ">
              <ArrowRightIcon />
            </div>
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default TestModal;
